import UMCButton from "../common/UMCButton"
import TextField from "../common/TextField"
import { SearchOutlined } from "@ant-design/icons"
import { PURPLE } from "../../styles/styleUtils";
import { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUserFilteredList, setUserTableSchema } from "../../store/reducers/UUMReducer";
import { getTranslated, tableListFilter } from "../../utils/CommonUtils";
import CustomTable from "../common/CustomTable";
import { useWindowSize } from "../customHooks/useWindowSize";
import { setContentLoading, setExtraContent } from "../../store/reducers/CommonReducer";
import { UUM_URL } from "../../utils/Config";
import { getTableSchema } from "../../store/actions/CommonActions";
import { UPDATE, OXE_ERROR, USERS } from "../../utils/Constants";
import UserProfileSummaryView from "./UserProfileSummaryView";
import CreateUserDetailView from "./CreateUserDetailView";
import confirmModal from "../common/confirmModal";
import { deleteUser, getUsersList, getUsersList2 } from "../../store/actions/UUMActions";
import debounce from 'lodash/debounce';
import { showOxeErrorsByCodesInDialog } from "../../store/actions/OxeActions";
import { sendGTMEvent } from "../../utils/GTMUtils";

const viewModes = {
    LIST: "list",
    SUMMARY: "summary",
    DETAIL: "detail"
}

const Users = () => {

    const [openPK, setOpenPK] = useState(false)
    const [viewMode, setViewMode] = useState(viewModes.LIST)
    const [selectedUser, setSelectedUser] = useState()
    const [searchText, setSearchText] = useState("")

    const userTableSchema = useSelector(state => state.uum.userTableSchema)
    const userFilteredList = useSelector(state => state.uum.userFilteredList)
    const userTableList = useSelector(state => state.uum.userTableList)
    const dict = useSelector(state => state.common.dict)
    const dispatch = useDispatch()

    const [width, height] = useWindowSize()

    useEffect(() => {
        dispatch(setContentLoading(true))

        !(userTableSchema?.length) && dispatch(getTableSchema({ url: `${UUM_URL}/schema/list/easyuser`, action: setUserTableSchema })) // Get Users Table schema

        // dispatch(getUsersList())
        dispatch(getUsersList(() => {
            dispatch(getUsersList2())
        }))
    }, [])

    useEffect(() => {
        if (userTableSchema?.length && userTableList)
            dispatch(setContentLoading(false))
    }, [userTableSchema, userTableList])

    useEffect(() => {
        let extraContent = []
        switch (viewMode) {
            case viewModes.LIST:
                extraContent = ["refresh", "help"];
                break;
            case viewModes.SUMMARY:
                extraContent = ["help"];
                break;
            case viewModes.DETAIL:
                extraContent = ["help"];
                break;
            default:
                break
        }

        dispatch(setExtraContent(extraContent))
    }, [viewMode])

    const handleClose = () => {
        setOpenPK(false)
    }

    const handleTableSearch = debounce((searchVal) => {
        setSearchText(searchVal)
        if (searchVal?.length >= 3 || searchVal === "") {
            const filteredArr = tableListFilter(userTableList, searchVal)
            dispatch(setUserFilteredList(filteredArr))
        }
    }, 300)

    const setListViewMode = (value) => {
        value && dispatch(getUsersList(() => {
            dispatch(setContentLoading(false))
            dispatch(getUsersList2())
        }))
        if (value) {
            dispatch(setContentLoading(false))
        }

        setViewMode(value ? viewModes.LIST : viewModes.SUMMARY)
        setViewMode(value ? viewModes.LIST : viewModes.SUMMARY)

        if (!value) // Send GTM event for user creation start
            sendGTMEvent({
                event: "umc_easy_user_config",
                action: "User creation started"
            })
    }

    const handleRowSelect = (rowData) => {
        setViewMode(viewModes.DETAIL)
        setSelectedUser(rowData.key)
        // Send GTM event for user details access
        sendGTMEvent({
            event: "umc_easy_user_config",
            action: "User details access"
        })
    }

    const handleRowDelete = (key) => {
        dispatch(setContentLoading(true))

        dispatch(deleteUser(key, (status, resp) => {
            if (status) {
                // Remove deleted user from local lists instead of refetching
                const updatedList = userTableList.filter(user => user.key !== key)
                const updatedFilteredList = userFilteredList.filter(user => user.id !== key)

                dispatch(setUserFilteredList(updatedFilteredList))
                dispatch({ type: "UUM_SET_USER_TABLE_LIST", payload: updatedList })
                dispatch(setContentLoading(false))
            } else {
                dispatch(setContentLoading(false))
                if (resp?.errorResponse?.[0]?.errorType === OXE_ERROR) {
                    dispatch(showOxeErrorsByCodesInDialog(resp));
                }
                else {
                    confirmModal({
                        title: "MSG_USER_DEL_FAIL",
                        content: resp?.errorMessage,
                        type: "error",
                        okText: "LABEL_OK"
                    });
                }
            }

            viewMode !== viewModes.LIST && setViewMode(viewModes.LIST)
        }))

        // Send GTM event for user deletion
        sendGTMEvent({
            event: "umc_easy_user_config",
            action: "User delete triggered"
        })
    }

    const showDeleteConfirm = (key) => {
        confirmModal({
            title: "MSG_SURE_DEL_USER",
            content: "MSG_CONFIRM",
            error: true,
            onOk() {
                handleRowDelete(key)
            }
        })
    }

    const getUsersHeader = () => {

        return <div className="inner-tab-hd-container">
            <TextField
                value={searchText}
                handleChange={handleTableSearch}
                className="user-search"
                prefix={<SearchOutlined style={{ fontSize: "10px", color: PURPLE }} />}
                placeholder={getTranslated(dict, "LABEL_SEARCH")}
            />

            <UMCButton label={getTranslated(dict, "LABEL_CREATE")} onClick={() => setListViewMode(false)} type="primary" className="cont-header-btn" />
            {/* <UMCButton label="Import" type="primary" className="cont-header-btn" />
            <UMCButton label="Export" type="primary" className="cont-header-btn" />
            <UMCButton label="Advanced mode" className="cont-header-btn last-option" /> */}
        </div>
    }

    const getTable = () => {

        return <CustomTable
            schema={userTableSchema}
            filteredData={userFilteredList}
            tableData={userTableList}
            updateTableAction={setUserFilteredList}
            handleRowSelect={handleRowSelect}
            handleRowDelete={(key) => showDeleteConfirm(key)}
            height={height <= 585 ? "22em" : "60vh"}
            tabKey={USERS}
        />
    }


    return <div id="inner-tab-content">
        {viewMode === viewModes.LIST ? <>
            <div style={{ marginBottom: "14px" }}>
                {getUsersHeader()}
            </div>
            {getTable()}
        </> :
            viewMode === viewModes.SUMMARY ? <UserProfileSummaryView
                setListViewMode={setListViewMode}
                heading_1={getTranslated(dict, "MSG_CHOOSE_PROF")}
                heading_2={getTranslated(dict, "MSG_SEL_PERSONALIZED_PROF")}
            /> :
                <CreateUserDetailView
                    selectedUser={selectedUser}
                    changeCreateMode={setListViewMode}
                    backToListView={setListViewMode}
                    mode={UPDATE}
                    handleUserDelete={showDeleteConfirm}
                />
        }
    </div>
}

export default memo(Users)